const Info = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            width="14px"
            height="14px"
            {...props}
        >
            <path
                fill="#080807"
                d="M7 6.417h.583V10.5H6.417V7.583a.584.584 0 010-1.166H7zM7 14A7 7 0 117 0a7 7 0 010 14zm0-1.167A5.833 5.833 0 107 1.167a5.833 5.833 0 000 11.666zm-.875-8.458c0-.483.388-.875.875-.875.483 0 .875.389.875.875A.873.873 0 017 5.25a.873.873 0 01-.875-.875z"
            />
        </svg>
    )
}

export default Info
